import { FormSkeleton } from '@globaleris/ui.library'
import { List, ListItem, makeStyles, Typography, useTheme } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { styles } from '../../floatingConcepts.styles'

interface VirtualBatteryDetailPanelProps {
  isLoading: boolean
  subjectDescription: string
  contractOrGroupCode: string
  balance: number
}
export const VirtualBatteryDetailPanel: React.FC<VirtualBatteryDetailPanelProps> = ({
  isLoading,
  subjectDescription,
  contractOrGroupCode,
  balance
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'floatingConcepts'])

  // Import Styles
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  const balanceClass = balance < 0 ? classes.negative : classes.positive

  // #region Handlers Starts
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <>
      {isLoading ? (
        <FormSkeleton withTitle={true} elevation={0} columns={1} inputs={3} />
      ) : (
        <List className={classes.resume}>
          <ListItem divider disableGutters>
            <Typography variant="caption">
              {t('floatingConcepts:components.virtualBatteryDetail.leftColumn.captions.balance')}
            </Typography>
            <Typography
              variant="h2"
              id="balance"
              className={balanceClass}
            >{`${parseFloat(balance.toFixed(2))} €`}</Typography>
          </ListItem>
          <ListItem divider disableGutters>
            <Typography variant="caption">
              {t('floatingConcepts:components.virtualBatteryDetail.leftColumn.captions.subject')}
            </Typography>
            <Typography variant="body2">{subjectDescription}</Typography>
          </ListItem>
          <ListItem divider disableGutters>
            <Typography variant="caption">
              {t(
                'floatingConcepts:components.virtualBatteryDetail.leftColumn.captions.contractOrGroupCode'
              )}
            </Typography>
            <Typography variant="body2">{contractOrGroupCode}</Typography>
          </ListItem>
        </List>
      )}
    </>
  )
}
